<template>
  <v-toolbar
    id="core-toolbar"
    text
    flat
  >
    <v-toolbar-items>
      <v-btn
        v-if="responsive"
        text
        icon
        @click.stop="onClickBtn"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-toolbar-items>

    <helper-loading />
    <v-menu
      v-if="getWhiteLabel"
      style="display: inline"
      offset-y
      right
      bottom
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :disabled="$apollo.loading"
          outlined
          small
          text
          v-on="on"
        >
          {{ getWhiteLabel.name }}
        </v-btn>
      </template>
      <v-sheet dense>
        <v-list-item
          v-for="(w, i) in whiteLabels"
          :key="i"
          dense
          @click="setWhiteLabel(w)"
        >
          <v-list-item-title>{{ w.name }}</v-list-item-title>
        </v-list-item>
      </v-sheet>
    </v-menu>

    <v-spacer />
    <v-toolbar-items v-if="me == undefined && !$apollo.loading">
      <v-flex py-3>
        <v-btn
          v-if="!$vuetify.breakpoint.xs"
          text
          @click="$router.push('/login')"
        >
          {{ $t("register.logIn") }}
        </v-btn>
      </v-flex>
    </v-toolbar-items>
    <v-toolbar-items v-if="me != undefined">
      <v-flex
        align-center
        layout
        py-2
      >
        <v-menu
          :nudge-width="270"
          offset-y
          left
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-avatar
              v-if="me.avatar != null"
              style="cursor: pointer; border: 1px solid #f6f8f9"
              :tile="false"
              :size="40"
              v-on="on"
            >
              <v-img
                :src="me.avatar"
                :lazy-src="me.avatar"
                max-height="40"
                contain
              />
            </v-avatar>
            <v-avatar
              v-else
              style="cursor: pointer"
              :tile="false"
              :size="40"
              :color="
                $vuetify.theme.dark
                  ? $vuetify.theme.themes.dark.surface
                  : $vuetify.theme.themes.light.surface
              "
              v-on="on"
            >
              <strong>
                <a>{{ me.name | uppercase | substring(0, 2) }}</a>
              </strong>
            </v-avatar>
          </template>
          <v-card class="me-info-card">
            <v-sheet dense>
              <v-list-item class="me-info">
                <v-list-item-content>
                  <v-list-item-title>{{ me.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ me.obfuscated_email }}
                    <br>
                    <v-chip
                      class="mt-3"
                      small
                      outlined
                      @click="$refs.depositfunds.open()"
                    >
                      {{ $t("toolbar.myBalance") }}:&nbsp;<b>
                        {{ usdtAmount }} USDT</b>
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="text-right">
                  <v-btn
                    class="ml-3"
                    x-small
                    text
                    outlined
                    @click="$refs.depositfunds.open()"
                  >
                    {{ $t("globals.depositButton") }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>

              <v-divider />

              <v-list-item @click="$router.push('/profile')">
                <v-list-item-icon>
                  <v-icon>mdi-account-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.myProfile")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="$router.push('/security')">
                <v-list-item-icon>
                  <v-icon>mdi-shield-account-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.security")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="$router.push('/myinvoices')">
                <v-list-item-icon>
                  <v-icon>mdi-text-box-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.myInvoices")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="me.unpaid_invoices">
                  <v-icon> mdi-alert-circle </v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-list-item
                v-if="getWhiteLabel"
                @click="$router.push('/affplans')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-vector-triangle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.affiliatePlans")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="getWhiteLabel"
                @click="$router.push('/gateways')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-credit-card-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("whitelabel.paymentSettings")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="getWhiteLabel"
                @click="$router.push('/modules/configuration')"
              >
                <v-list-item-icon>
                  <v-icon>mdi-apps</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("whitelabel.modulesSettings")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="chatIDExists"
                @click="onEnableLiveChat"
              >
                <v-list-item-icon>
                  <v-icon>mdi-face-agent</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.liveChat")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    v-model="showChat"
                    color="primary"
                    @click.stop=""
                  />
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>
                    {{
                      $vuetify.theme.dark
                        ? "mdi-moon-waxing-crescent"
                        : "mdi-weather-sunny"
                    }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.darkMode")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch
                    v-model="$vuetify.theme.dark"
                    color="primary"
                    @click.stop=""
                  />
                </v-list-item-action>
              </v-list-item>
              <v-divider />
              <v-list-item @click="$router.push('/login')">
                <v-list-item-icon>
                  <v-icon>mdi-power</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      $t("toolbar.logOut")
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>
          </v-card>
        </v-menu>
      </v-flex>
    </v-toolbar-items>
    <helper-deposit-funds ref="depositfunds" />
  </v-toolbar>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

import ME_QUERY from "@/graphql/queries/Me.gql";
import USER_WHITELABELS_QUERY from "@/graphql/queries/WhiteLabels.gql";

const observer = new IntersectionObserver((entries, observer) => {
      if(document.querySelector("#tidio-chat-iframe")) {
        document.querySelector("#tidio-chat-iframe").className = "iframe-custom";

        if(document.querySelector("#tidio-chat-iframe").contentWindow.document.readyState) {
          setTimeout(() => {
            document.querySelector("#tidio-chat-iframe").contentDocument.body.querySelector("#button-body").addEventListener("click", function() {
            document.getElementById("tidio-chat-iframe").classList.remove("iframe-custom");

            setTimeout(() => {
              document.querySelector("#tidio-chat-iframe").contentDocument.body.querySelector(".exit-chat").addEventListener("click", function() {
                  document.getElementById("tidio-chat-iframe").className = "iframe-custom";
                });
              }, 100)
            });
          }, 100);
        }
      }
    });

export default {
  data() {
    return {
      title: null,
      responsive: false,
      responsiveInput: false,
    };
  },
  computed: {
    ...mapGetters("app", ["getShowChat"]),
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    usdtAmount() {
      if (!this.me) return 0;
      let amount = this._.find(this.me.wallet_balance, {
        currency: "USDT",
      });
      return amount.credit;
    },
    chatIDExists() {
      const provider = this.$ls.get("config");
      if (provider.public_config && provider.public_config.tidio_id) {
        return true;
      }
      return false;
    },
    showChat: {
      get() {
        return this.getShowChat;
      },
      set(val) {
        this.setShowChat(val);
      },
    },
  },
  watch: {
    showChat(val, oldVal) {
      this.$ls.set("show-chat", val);
      window.tidioChatApi.display(val);
      if(val) {
        setTimeout(() => {
          observer.observe(document.querySelector("#tidio-chat-iframe"));
        }, 100);
      } else {
        observer.disconnect()
      }
    },
    $route(val) {
      this.title = val.name;
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    this.$store.subscribe((mutation, state) => {
      if (
        mutation.type == "user/updateUser" &&
        this.$apollo.queries.me != undefined
      ) {
        this.$apollo.queries.me.refetch();
      }
    });

    const onTidioChatApiReady = () => {
      if (this.$ls.get("show-chat") == undefined) {
        this.showChat = true;
      } else {
        this.showChat = this.$ls.get("show-chat");
      }
      window.tidioChatApi.display(this.showChat);
      observer.observe(document.querySelector("#tidio-chat-iframe"));
    };
    if (window.tidioChatApi) {
      window.tidioChatApi.on("ready", onTidioChatApiReady);
    } else {
      document.addEventListener("tidioChat-ready", onTidioChatApiReady);
    }
  },
  beforeDestroy() {
    observer.disconnect()
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer", "setShowChat"]),
    ...mapMutations("user", ["setUser"]),
    ...mapMutations("whitelabel", ["setWhiteLabel"]),
    onEnableLiveChat() {
      this.showChat = !this.showChat;
    },
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 1367) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
  },
  apollo: {
    whiteLabels: {
      query: USER_WHITELABELS_QUERY,
      variables() {
        return {
          owner_uuid: this.getUser.uuid,
        };
      },
      result({ loading, data }) {
        if (loading) {
          return;
        }
        if (data.whiteLabels && data.whiteLabels.length > 0) {
          data.whiteLabels.forEach((wl) => {
            wl.modules.forEach((module) => {
              if (
                module.public_config &&
                typeof module.public_config !== "object"
              ) {
                module.public_config = JSON.parse(module.public_config);
                return module;
              }
            });
          });
          this.setWhiteLabel(data.whiteLabels[0]);
        } else {
          this.setWhiteLabel(null);
        }
      },
      skip() {
        return !this.getUser;
      },
    },
    me: {
      query: ME_QUERY,
      fetchPolicy: "network",
      skip() {
        return localStorage.getItem("auth-token") == null;
      },
      result(data) {
        if (!data.loading) {
          this.setUser(this.me);
          this.$i18n.locale = this.me.language;
          localStorage.setItem("language", this.$i18n.locale);
          document.tidioChatLang = this.$i18n.locale;
          if (window.tidioChatApi) {
            setTimeout(() => {
              window.tidioChatApi.setVisitorData({
                name: this.getUser.name,
                email: this.getUser.email,
              });
            }, 2000);
          }
        }
      },
    },
  },
};
</script>

<style lang="scss">
#core-toolbar {
  .btn-buy {
    height: 19px;
    margin-left: 5px;
    margin-top: -2px;
  }
  .v-toolbar__title {
    font-size: 0.9rem;
    line-height: 17px;
    margin-top: 4px;
    p {
      margin: 0;
      font-size: 12px;
    }
  }
  a {
    text-decoration: none;
  }
}
.me-info-card {
  padding: 2px !important;
  .v-list {
    padding: 0;
  }
  .v-list-item__title {
    font-weight: 500;
    font-size: 0.9rem;
  }
}
</style>
